import { render, staticRenderFns } from "./applist.vue?vue&type=template&id=95b07138&scoped=true&"
import script from "./applist.vue?vue&type=script&lang=js&"
export * from "./applist.vue?vue&type=script&lang=js&"
import style0 from "./applist.vue?vue&type=style&index=0&id=95b07138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b07138",
  null
  
)

export default component.exports